import React from 'react'

function MapSpineer() {
  return (
  <div className="map-spinner-overlay">
    <div className="spinner" />
  </div>
  )
}

export default MapSpineer